import React, { FC, useMemo } from 'react';
import { Page, StyleSheet, Text, View } from '@react-pdf/renderer';
import { useTranslation } from 'react-i18next';
import { THEME as theme } from '../../../../styles/theme';
import PageCount from '../../components/PageCount/PageCount';
import PageSection from '../../components/PageSection/PageSection';

const styles = StyleSheet.create({
  page: {
    position: 'relative',
    fontFamily: 'Roboto-Regular',
    backgroundColor: theme.colors.neutral.secondary,
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
  },
  description: {
    width: '100%',
  },
  cards: {
    width: '100%',
    margin: 0,
    padding: 0,
    backgroundColor: theme.colors.neutral.primary[0],
    borderRadius: 8,
  },
  card: {
    display: 'flex',
    width: '100%',
    padding: `${theme.layout.spacing.centy} ${theme.layout.spacing.deka}`,
    alignItems: 'center',
    flexDirection: 'row',
    gap: 16,
  },
  index: {
    margin: 0,
    padding: `${theme.layout.spacing.mikro} ${theme.layout.spacing.centy}`,
    fontFamily: 'Roboto-Bold',
    fontSize: 40,
    color: theme.colors.primary[100],
  },
  content: {
    width: 380,
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
  },
  title: {
    fontFamily: 'Roboto-Bold',
  },
});

const ReflectionTaskPage: FC = () => {
  const { t } = useTranslation();

  const tasks = useMemo(
    () => [
      {
        id: 1,
        title: t('results.report.reflectionTask.tasks.energyGain.title'),
        text: t('results.report.reflectionTask.tasks.energyGain.description'),
      },
      {
        id: 2,
        title: t('results.report.reflectionTask.tasks.energyDrain.title'),
        text: t('results.report.reflectionTask.tasks.energyDrain.description'),
      },
      {
        id: 3,
        title: t('results.report.reflectionTask.tasks.positiveAspects.title'),
        text: t('results.report.reflectionTask.tasks.positiveAspects.description'),
      },
    ],
    [t]
  );

  return (
    <Page id="reflection-task" orientation="portrait" size="A4" style={styles.page} wrap={false}>
      <PageSection title={t('results.report.pdf.sections.reflectionTask')}>
        <View style={styles.container}>
          <Text style={styles.description}>{t('results.report.reflectionTask.description')}</Text>
          <View style={styles.cards}>
            {tasks.map(({ id, title, text }) => (
              <View
                style={[
                  styles.card,
                  {
                    borderBottom:
                      id !== 3 ? `1px solid ${theme.colors.neutral.primary[30]}` : 'none',
                  },
                ]}
                key={id}
              >
                <Text style={styles.index}>{id}</Text>
                <View style={styles.content}>
                  <Text style={styles.title}>{title}</Text>
                  <Text style={styles.description}>{text}</Text>
                </View>
              </View>
            ))}
          </View>
        </View>
      </PageSection>
      <PageCount />
    </Page>
  );
};

export default ReflectionTaskPage;
